import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

import ResumeDropzone from "@/components/form/ResumeDropzone.jsx";
import axios from "axios";
import { UPLOAD_PROFILE_RESUME} from "@/constants/routes/index.jsx";
import ErrorNotification from "@/components/dialogs/ErrorNotification.jsx";
import {useModal} from "@/hooks/useModal.jsx";
import {urlToFile} from "@/utils/urlToFile.jsx";

export default function ResumeUpload({file, onChange, error, autoUpload = false}) {
    const {openModal} = useModal();

    const [loading, setLoading] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);

    useEffect(() => {
        if (file instanceof File) {
            setUploadedFile(file);
        } else if (typeof file === 'string') {
            urlToFile(file).then(new_file => {
                setUploadedFile(new_file);
            });
        } else {
            setUploadedFile(null);
        }
    }, [file]);

    const upload = async (file) => {
        try {
            const formData = new FormData();
            if (file) {
                formData.append('resume', file);
            }

            const response = await axios.post(UPLOAD_PROFILE_RESUME, formData, {
                withCredentials: true,
                validateStatus: function (status) {
                    return status < 500;
                },
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'multipart/form-data',
                },
            });

            switch (response.status) {
                case 200:
                    return response.data;
                    break;
                case 422:
                    if (response.data?.errors?.resume) {
                        openModal(
                            <ErrorNotification>
                                {response.data?.errors?.resume[0]}
                            </ErrorNotification>
                        );
                    }
                    break;
                default:
                    openModal(
                        <ErrorNotification>
                            {response?.data?.errorNotification}
                        </ErrorNotification>
                    );
            }
        } catch (error) {
            console.error(error);
            if(error?.message?.length > 0) {
                openModal(
                    <ErrorNotification>
                        {error.message}
                    </ErrorNotification>
                );
            } else {
                openModal(
                    <ErrorNotification/>
                );
            }
        }
    };

    const handleChange = (file) => {
        setLoading(true);

        if(autoUpload) {
            upload(file)
                .then((data) => {
                    onChange(data?.resume)
                    setLoading(false);
                });
        } else {
            onChange(file)
            setLoading(false);
        }
    }

    return (
        <>
            <ResumeDropzone
                loading={loading}
                file={uploadedFile}
                error={error}
                onDrop={(files) => {
                    handleChange(files[0]);
                }}
                onRemove={() => {
                    handleChange(null);
                }}
            />
        </>
    );
}

ResumeUpload.propTypes = {
    onChange: PropTypes.func,
};
